<template>
  <div class="admin-shops">
    <page-title title="筛选">
      <el-row class="admin-shops__filter-header" :gutter="20">
        <el-col :xl="4" :span="6">
          <span>店铺ID：</span>
          <el-input v-model="filter.id" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>店铺名称：</span>
          <el-input v-model="filter.name" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>店铺类型：</span>
          <el-select clearable v-model="filter.type" placeholder="请选择">
            <el-option value="PERSONAL" label="个人店铺"></el-option>
            <el-option value="ENTERPRISE" label="机构店铺"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>注册手机号：</span>
          <el-input v-model="filter.phone" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="5" :span="6">
          <span>店铺状态：</span>
          <el-select clearable v-model="filter.state" placeholder="请选择">
            <el-option v-for="s in SHOPSTATUS" :key="s" :label="SHOPSTATUSZH[s]" :value="s"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button :disabled="loading" @click="getList">查询</el-button>
          <el-button @click="filter = {};getList()">重置</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="admin-shops__body" v-if="pageStatus">
        <el-table v-loading="loading" :data="shopData" style="width: 100%" :header-cell-style="{ backgroundColor: `#f7f7f7` }">
          <el-table-column type="index" width="110" align="center"> </el-table-column>
          <el-table-column prop="id" label="店铺ID" width="145"> </el-table-column>
          <el-table-column prop="name" label="店铺名称" width="165"> </el-table-column>
          <el-table-column prop="type" label="店铺类型" width="130" :formatter="shopType"> </el-table-column>
          <el-table-column prop="userInfo.mobile" label="注册手机号" width="155"> </el-table-column>
          <el-table-column prop="contact.email" label="邮箱" width="240"> </el-table-column>
          <el-table-column label="店铺状态" width="300">
            <template slot-scope="{ row }">
              <shop-state-label :status="row.state"></shop-state-label>
            </template>
          </el-table-column>
          <el-table-column prop="createdDate" label="开店时间" width="230"> </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="100">
            <template slot-scope="{ row }">
              <router-link style="text-decoration:none;color:#005BFF;" :to="`/shop/${row.id}/${row.createdBy}`">
                <span>详情</span>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination :total="total" :current-page.sync="currentPage" :page-size.sync="pageSize" @size-change="getList"></cus-pagination>
      </div>
      <div class="page-not-ready" v-else>
        数据加载失败，请刷新试试~
      </div>
    </page-title>
  </div>
</template>
<script>
import _pageFail from '@/assets/style/_page-status.scss';
import PageTitle from '@/components/pageTitle.vue';
import ShopStateLabel from './components/shopStateLabel.vue';
import CusPagination from '@/components/cusPagination.vue';
import { shopList } from '@/api/req';
import { SHOP_STATE, SHOP_STATE_zh } from './eum';

export default {
  name: 'shop',
  components: {
    PageTitle,
    ShopStateLabel,
    CusPagination
  },
  data() {
    return {
      pageStatus: true,
      loading: false,
      filter: {},
      shopData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: {
    SHOPSTATUS() {
      return SHOP_STATE;
    },
    SHOPSTATUSZH() {
      return SHOP_STATE_zh;
    }
  },
  watch: {
    currentPage() {
      this.getList();
    }
  },
  methods: {
    getList() {
      this.loading = true;
      const reqPara = {
        ...this.filter,
        pageSize: this.pageSize,
        pageNumber: this.currentPage
      };
      this.$ajax
        .get(shopList, reqPara)
        .then(({ data }) => {
          this.shopData = data.rows;
          this.total = data.total;
          this.pageStatus = true;
          this.loading = false;
        })
        .catch(err => {
          console.log(err.data);
          this.pageStatus = false;
          this.loading = false;
        });
    },
    shopType({ type }) {
      return type === 'PERSONAL' ? '个人店铺' : '机构店铺';
    }
  },
  created() {
    const { query } = this.$route;
    if (JSON.stringify(query) !== '{}') {
      this.filter = Object.assign(this.filter, query);
    }
    this.getList();
    // this.pageStatus = true
  }
};
</script>

<style lang="scss">
.admin-shops {
  &__body {
    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
    .el-switch__label {
      color: #8998a0;
    }
    .el-switch__label.is-active {
      color: #005bff;
    }
  }
}
</style>
